import { Zoom } from "./Zoom.js";
export const ACTION_ZOOM_IN = "zoom-in";
export const ACTION_ZOOM_OUT = "zoom-out";
export default Zoom;
